/**
 * PC ヘッダー「売りたい」ホバーでエリアパネルを表示（Figma 4852-34268）
 */

import $ from 'jquery';

const PC_MQ = window.matchMedia('(min-width: 768px)');
const PANEL_OFFSET_BELOW_HEADER = 12;

function setPanelOpen(item, trigger, panel, open) {
	item.classList.toggle('is-open', open);
	trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
	panel.setAttribute('aria-hidden', open ? 'false' : 'true');
}

function positionSellPanel(item, panel) {
	const header = item.closest('.l-header');
	if (!header) return;

	const headerRect = header.getBoundingClientRect();
	const itemRect = item.getBoundingClientRect();
	const top = headerRect.bottom + PANEL_OFFSET_BELOW_HEADER - itemRect.top;
	panel.style.top = `${top}px`;
}

export function initHeaderNavSell() {
	const item = document.querySelector('.l-header__navItem--sell');
	if (!item) return;

	const trigger = item.querySelector('.l-header__navLink--sell');
	const panel = item.querySelector('.l-header__navPanel');
	if (!trigger || !panel) return;

	let closeTimer = null;

	const clearCloseTimer = () => {
		if (closeTimer) {
			clearTimeout(closeTimer);
			closeTimer = null;
		}
	};

	const syncPanelPosition = () => {
		if (!PC_MQ.matches) {
			panel.style.top = '';
			return;
		}
		positionSellPanel(item, panel);
	};

	const openPanel = () => {
		if (!PC_MQ.matches) return;
		clearCloseTimer();
		syncPanelPosition();
		setPanelOpen(item, trigger, panel, true);
	};

	const closePanel = () => {
		if (!PC_MQ.matches) return;
		clearCloseTimer();
		closeTimer = window.setTimeout(() => {
			setPanelOpen(item, trigger, panel, false);
		}, 120);
	};

	const togglePanelSp = (e) => {
		if (PC_MQ.matches) return;
		e.preventDefault();
		const isOpen = item.classList.contains('is-open');
		if (isOpen) {
			setPanelOpen(item, trigger, panel, false);
			$(panel).slideUp(200);
		} else {
			setPanelOpen(item, trigger, panel, true);
			$(panel).slideDown(200);
		}
	};

	const onPcChange = () => {
		if (!PC_MQ.matches) {
			clearCloseTimer();
			setPanelOpen(item, trigger, panel, false);
			panel.style.top = '';
			panel.style.display = 'none';
			return;
		}
		panel.style.display = '';
		syncPanelPosition();
	};

	syncPanelPosition();
	window.addEventListener('resize', syncPanelPosition);

	item.addEventListener('mouseenter', openPanel);
	item.addEventListener('mouseleave', closePanel);
	item.addEventListener('focusin', openPanel);
	item.addEventListener('focusout', (e) => {
		if (!item.contains(e.relatedTarget)) {
			closePanel();
		}
	});
	trigger.addEventListener('click', togglePanelSp);

	const observer = new MutationObserver(() => {
		if (PC_MQ.matches) return;
		const isHeaderHidden = document.documentElement.classList.contains('is-sp-header-hidden');
		const isOpen = item.classList.contains('is-open');
		if (isHeaderHidden && isOpen) {
			setPanelOpen(item, trigger, panel, false);
			$(panel).stop(true, true).slideUp(200);
		}
	});

	observer.observe(document.documentElement, {
		attributes: true,
		attributeFilter: ['class']
	});

	if (typeof PC_MQ.addEventListener === 'function') {
		PC_MQ.addEventListener('change', onPcChange);
	} else {
		PC_MQ.addListener(onPcChange);
	}
}
